import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { hairColorPalette } from 'enrollment/app/constants';
import {
  selectAvatarHairColorAction,
  selectFamilyAvatarHairColorAction,
} from './AvatarActions';
import {
  AvatarColorContainer,
  ColorPaletteButton,
  StyledTypography,
} from './AvatarStyled';

interface AvatarHairColorType {
  enrollment: {
    chooseAvatar: {
      avatarColorPalatteDisabled: boolean;
    };
  };
}

export const AvatarHairColor = () => {
  const { t } = useTranslation('pages.enrollmentDashboard');
  const dispatch = useDispatch();

  const selectAvatarHairColorDisabled = useSelector(
    (state: AvatarHairColorType) =>
      state?.enrollment?.chooseAvatar?.avatarColorPalatteDisabled
  );

  const state = useSelector((state: any) => state?.enrollment);
  const selectorState = state?.authentication?.redirectLink;
  const [selectedHairColorId, setSelectedHairColorId] = useState<string | null>(
    null
  );
  const [announcement, setAnnouncement] = useState('');

  const familyContainerWidth = document.querySelector(
    '#enrollment-family-container'
  ) as HTMLElement;

  const handleAvatarHairColorSelection = (item: any) => {
    setSelectedHairColorId(item.id);
    setAnnouncement(`Selected hair color: ${item.name}`);

    if (selectorState === '/enrollment/profile/edit') {
      dispatch(selectAvatarHairColorAction(item));
    }
    if (selectorState === '/enrollment/family') {
      dispatch(selectFamilyAvatarHairColorAction(item));
    }
  };

  return (
    <AvatarColorContainer role="group" aria-labelledby="idref4">
      <StyledTypography variant="overline" gutterBottom id="idref4">
        {t('avatarHairColorTitle')}
      </StyledTypography>
      <div role="alert" aria-live="assertive" className="sr-only">
        {announcement}
      </div>
      <ul className="avatar-grid">
        {hairColorPalette?.map((item) => {
          const isSelected = selectedHairColorId === item.id;

          return (
            <li key={item.id}>
              <ColorPaletteButton
                type="button"
                disabled={!selectAvatarHairColorDisabled}
                aria-label={item.name}
                aria-pressed={isSelected}
                className={isSelected ? 'selected' : ''}
                style={{ position: 'relative' }}
                onClick={() => handleAvatarHairColorSelection(item)}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  dangerouslySetInnerHTML={{ __html: item.code }}
                  aria-hidden="true"
                  role="presentation"
                />
                {isSelected && <span className="sr-only">selected</span>}
                {isSelected && (
                  <i
                    className="ph-fill ph-check-fat checkmark"
                    aria-hidden="true"
                    role="presentation"
                  ></i>
                )}
              </ColorPaletteButton>
            </li>
          );
        })}
      </ul>
    </AvatarColorContainer>
  );
};
